<template>
  <div id="navBarhome">
    <!-- 工作动态-01 -->
    <div class="Learning-education001">
      <div class="channelNameBox">
        <span class="channelName">{{ channelName }}</span>
        <span
          v-if="channelList.length > 3"
          class="moreContent"
          @click="moreMethod(channelId)"
        >
          <img :src="rightArrorImg" alt="" />
        </span>
      </div>

      <div class="classroom-box">
        <ul class="info-list">
          <li
            class="img-li"
            v-for="item in channelList.slice(0, dataBannerSize)"
            :key="item.name"
            @click="detailContent(item)"
          >
            <!-- 有图 -->
            <div
              v-if="item.displayResourcesLenth > 0 && !item.imagesShow"
              href="##"
              target="_blank"
              class="education001-href-auto"
            >
              <div class="photo-div">
                <img
                  v-if="item.displayResourcesLenth != 0"
                  :src="item.displayResources[0].sourceUrl"
                  alt=""
                />
              </div>
              <div class="label-div">
                <div>
                  <h3 class="title">
                    {{ item.title }}
                  </h3>
                </div>
                <p class="education001-p-auto">
                  {{ item.displayDate.substring(0, 10) }}
                </p>
              </div>
            </div>

            <!--  无图 -->
            <div
              v-if="item.displayResourcesLenth == 0 && !item.imagesShow"
              href="##"
              target="_blank"
              class="education001-href-auto emptyLeftImg"
            >
              <div class="label-div">
                <div>
                  <h3 class="title">
                    {{ item.title }}
                  </h3>
                </div>
                <p class="education001-p-auto">
                  {{ item.displayDate.substring(0, 10) }}
                </p>
              </div>
            </div>

            <!-- 图集展示 -->
            <div
              v-if="item.displayResourcesLenth > 0 && item.imagesShow"
              class="imagesShow"
              @click="view(item)"
            >
              <div class="imagesNum" v-if="item.albumTotalCount > 1">
                <span class="imagesNumTxt">{{ item.albumTotalCount }}</span>
                图
              </div>
              <van-grid
                :column-num="item.columnNum"
                :gutter="1"
                :border="borderFlag"
              >
                <van-grid-item
                  v-for="gridItem in item.imagesList"
                  :key="gridItem"
                >
                  <van-image :class="getClass(item)" :src="gridItem.thumbUrl" />
                </van-grid-item>
              </van-grid>
              <div></div>
              <div class="imageTitle">{{ item.title }}</div>

              <p class="imageClockTime">
                {{ item.displayDate.substring(0, 10) }}
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div class="emptyMessage" v-if="channelList.length == 0">
        暂无数据~
      </div>
    </div>
  </div>
</template>

<script>
import { share } from "@/common/utils";

export default {
  name: "",
  props: {
    channelId: String,
    channelName: String
  },
  data() {
    return {
      loading: false,
      finished: false,
      pageNo: 1,
      bannerSize: 3,
      dataBannerSize: 3,
      borderFlag: false,

      channelList: [],
      rightArrorImg: require("@/assets/images/bs/arrowRight.svg")
    };
  },
  components: {},
  mounted() {
    const info = {
      title: "中国共产党上海市宝山区第八次代表大会", //标题
      summary: "更多精彩内容，下载宝山汇App", //简介
      link: window.location.href, //链接地址
      imageUrl: "https://assets.shmedia.tech/icon/bs.png"
    };
    share(info);
    // 初始化数据
    this.getData(this.channelId);
  },
  methods: {
    getData(channelId) {
      this.$http.post("/app/news/content/list", {
        data: {
          pageNo: this.pageNo,
          pageSize: "20",
          channel: { id: channelId },
          orderBy: "release_desc"
        },
        success: data => {
          if (data.records.length) {
            for (let t of data.records) {
              if (t.displayResources && t.displayResources.length > 0) {
                t.displayResourcesLenth = t.displayResources.length;
              } else {
                t.displayResourcesLenth = 0;
              }

              let types = t.displayStyle;
              if (types === "plain-text") {
                // 无图
                t.style = "small";
              }
              if (types === "inline-image") {
                // 小图
                t.style = "small";
              }
              if (types === "image") {
                // 大图
                t.style = "bigpic";
              }
              if (types === "v-image") {
                // 1张竖图
                t.style = "small";
              }
              if (types === "multi-image") {
                // 多张横图
                t.style = "bigpic";
              }
              if (types == "video") {
                //视频
                t.style = "video";
              }
              // 图集展示
              if (
                this.channelName === "图片集锦" &&
                t.displayResourcesLenth > 0
              ) {
                t.imagesShow = true;

                if (t.displayResourcesLenth >= 4) {
                  const newArray = [];
                  for (let i = 0; i < 4; i++) {
                    newArray[i] = t.displayResources[i];
                  }
                  t.imagesList = newArray;

                  t.columnNum = 2;
                } else {
                  t.columnNum = t.displayResourcesLenth;
                  t.imagesList = t.displayResources;
                }
              } else {
                t.style = "small";
              }
              this.channelList.push(t);
            }
            this.pageNo++;
          } else {
            this.finished = true;
          }
          this.loading = false;
        }
      });
    },
    detailContent(item) {
      const agent = window.navigator.userAgent.toLowerCase();
      const isRmt = -1 != agent.indexOf("rmt"); //RMT
      if (isRmt) {
        rmt.openAction({
          actionUrl: item.actionUrl, //链接地址
          closing: false //打开链接后，是否关闭本页面
        });
      } else {
        location.href = item.shareUrl;
      }
    },
    // 跳转更多列表页
    moreMethod(channelId) {
      this.$router.push({
        path: "/bsList",
        query: {
          channelId: channelId,
          channelName: this.channelName
        }
      });
    },
    getClass(item) {
      if (item.displayResources && item.displayResources.length == 1) {
        return "oneImage";
      }
    }
  }
};
</script>

<style scope>
@import "../assets/bsHome.css";
.imageTitle {
  margin-bottom: 5px;
  margin-top: 10px;
  font-size: 17px;
}
.imageClockTime {
  width: 220px;
  margin-top: 10px;
  width: 100%;
  font-size: 14px;
}
.imagesNum {
  width: fit-content;
  padding: 2px 10px;
  position: absolute;
  background-color: rgb(53 51 51 / 76%);
  margin-top: 0.4rem;
  z-index: 100;
  margin-left: 10px;
  border-radius: 5px;
  font-size: 14px;
  color: white;
}
.imagesNumTxt {
  font-size: 14px;
}
</style>
